import { Box, Button, CircularProgress, Divider, Grid, Link, Stack, Tooltip, Typography } from "@mui/material";
import TagsSituacao from "../../TagsSituacao";
import { TTagsSituacao } from "../../../types/ITagSituacao";
import moment from "moment";
import { IDetalheTarefas, TDetalheProcessoAnexos } from "../../../types/api/bpm/detalhar-processo";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import truncarString from "../../../helpers/truncarString";
import { AuthContext } from "../../../contexts/AuthContext";
import { useContext, useMemo, useState } from "react";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DialogEnviarArquivosProcesso from "../Dialogs/DialogEnviarArquivosProcesso";
import TableMenuOptions from "../../TableMenuOptions";
import DoneIcon from '@mui/icons-material/Done';
import { useMutation, useQueryClient } from "react-query";
import axiosClient from "../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import DialogFinalizarProcesso from "../Dialogs/DialogFinalizarTarefa";
import FolderZipOutlined from '@mui/icons-material/FolderZipOutlined';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import DialogVisualizacaoArquivos from "../../../screens/Financeiro/components/SolicitarAnaliseCredito/FormSolicitacao/DialogVisualizacaoArquivos";
import { useNavigate } from "react-router-dom";

export default function Info({
    usuario,
    usuario_status,
    perfil,
    perfil_solicitante,
    criadoEm,
    situacao,
    arquivos,
    codigo,
    tarefas,
    codigo_publico,
    tipo_publico,
    proximo_processo
}: InfoProps) {

    const queryClient = useQueryClient();
    const { token, getUserData, possuiPerfilId } = useContext(AuthContext);
    const user = getUserData()
    const navigate = useNavigate();

    const idProcesso = tarefas[0].processo_id
    const tarefaAtual = tarefas[tarefas.length - 1]

    const [openModalUpload, setOpenModalUpload] = useState(false)
    const [openFinalizarTarefa, setOpenFinalizarTarefa] = useState(false)
    const [openModalViewer, setopenModalViewer] = useState(false);

    const { mutate: finalizarTarefa, isLoading: isLoadingFinalizarTarefa } = useMutation({
        mutationKey: 'finalizar-processo',
        mutationFn: ({ idProcesso, motivoFinalizar }: { idProcesso: number, motivoFinalizar: string }) => {
            return axiosClient.post(`/finalizar-processo/${idProcesso}`, { motivo_finalizar: motivoFinalizar });
        },
        onError: (error) => {
            console.error(error);
        },
        onSuccess: () => {
            enqueueSnackbar('Tarefa finalizada com sucesso!', { variant: 'success' });
            queryClient.invalidateQueries("detalhar-processo")
            queryClient.invalidateQueries("pesquisar-processos-fazendo")
            queryClient.invalidateQueries("pesquisar-processos-finalizados")
            queryClient.invalidateQueries("pesquisar-tarefas-para-fazer")
        }
    });

    const { mutate: baixarTodosArquivos, isLoading: isLoadingBaixarTodos } = useMutation({
        mutationKey: 'baixar-todos-arquivos',
        mutationFn: () => axiosClient.get(`/baixar-todos-arquivos`, {
            params: { ids: arquivos.map(i => i.id) },
            responseType: 'blob'
        }),
        onError: (error) => {
            console.error(error);
            enqueueSnackbar("Error ao baixar os arquivos", { variant: "error" })
        },
        onSuccess: ({ data }) => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `arquivos_processo_${codigo}.zip`);

            document.body.appendChild(link);
            link.click();

            link.parentNode?.removeChild(link);
        }
    });

    const handleFinalizarPress = () => {
        if (!podeFinalizarProcesso) setOpenFinalizarTarefa(true);
        return;
    }
    const handleFinalizarTarefa = (motivoFinalizar: string) => {
        setOpenFinalizarTarefa(false)
        finalizarTarefa({ idProcesso: Number(idProcesso), motivoFinalizar })
    }

    const podeFinalizarProcesso = useMemo(() => {
        if(usuario_status === 'Inativo' && perfil_solicitante) {
            return (!user?.perfis_vinculados.some(perfil => perfil.nome === perfil_solicitante)) && situacao !== 'Finalizado' && !isLoadingFinalizarTarefa;
        }
        return !(usuario === user?.nome && situacao !== 'Finalizado' && !isLoadingFinalizarTarefa);
    }, [usuario, usuario_status, user, situacao, isLoadingFinalizarTarefa, perfil_solicitante]);

    return (
        <Box position={'relative'} display={'flex'} justifyContent={'space-between'}>
            <Box height={{ xs: "unset", md: 700 }} overflow="auto">
                <Grid container>
                    <Grid size={{ xs: 6, sm: 4, md: 12 }}>
                        <Box mb={2}>
                            <Typography variant="caption">Criado por</Typography>
                            <Typography fontWeight="bold" fontSize={22}>{usuario}</Typography>
                            <Typography component="div" variant="caption">{perfil}</Typography>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 6, sm: 4, md: 12 }}>
                        <Box mb={2}>
                            <Typography variant="caption">Data de criação</Typography>
                            <Typography fontWeight="bold">{moment(criadoEm).format('DD/MM/YYYY HH:mm')}</Typography>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 6, sm: 4, md: 12 }}>
                        <Box mb={2}>
                            <Typography component="div" variant="caption">Situação</Typography>
                            <TagsSituacao
                                situacao={situacao}
                            />
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        {
                            arquivos.length > 0 &&
                            <Box
                                display="flex"
                                flexDirection="column"
                                gap={1}
                                height={{ xs: 150, md: "unset" }}
                            >
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography variant="caption">Arquivos</Typography>
                                </Box>

                                <Box
                                    overflow="auto"
                                >
                                    {
                                        arquivos.map(arquivo => (
                                            <Tooltip title={arquivo.nome} placement="right-start">
                                                <Box display="flex" gap={0.5}>
                                                    <AttachFileIcon sx={{ fontSize: 14 }} />
                                                    <Link
                                                        key={arquivo.id}
                                                        href={`${process.env.REACT_APP_API}/api/baixar-arquivo/${arquivo.id}?token=${token}`}
                                                        variant="caption"
                                                        underline="hover"
                                                    >
                                                        {truncarString(arquivo.nome, 25)}
                                                    </Link>
                                                </Box>
                                            </Tooltip>
                                        ))
                                    }
                                </Box>
                            </Box >
                        }




                        <>
                            {isLoadingBaixarTodos && <CircularProgress size={15} />}

                            {
                                arquivos.length > 1 && !isLoadingBaixarTodos &&
                                <Box component="div" onClick={() => baixarTodosArquivos()} display="flex" sx={{ mt: 0 }} gap={0.5}>
                                    <FolderZipOutlined sx={{ fontSize: 14 }} />
                                    <Link
                                        href="#"
                                        variant="caption"
                                        underline="hover"
                                    >
                                        Baixar todos
                                    </Link>
                                </Box>
                            }
                        </>

                        <Button
                            disabled={tarefaAtual.bloqueia_anexo_processo}
                            variant="outlined"
                            size="small"
                            startIcon={<FileUploadIcon />}
                            sx={{ my: 2 }}
                            onClick={() => setOpenModalUpload(true)}
                        >
                            Enviar arquivos
                        </Button>
                    </Grid>
                    {
                        proximo_processo && proximo_processo.length > 0 &&
                        <Grid size={{ xs: 12 }}>
                            <Stack direction={'column'} spacing={2}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    fullWidth
                                    onClick={() => {
                                        if (proximo_processo) {
                                            navigate(`/tarefas?detalhe-processo=${proximo_processo}`);
                                            window.location.reload();
                                        }
                                    }}
                                    disabled={!proximo_processo}
                                    sx={{ mt: 2 }}
                                >
                                    Próximo processo
                                </Button>
                            </Stack>
                        </Grid>
                    }
                </Grid>

                <Divider sx={{ display: { xs: "block", md: "none" } }} />

                {
                    openModalUpload &&
                    <DialogEnviarArquivosProcesso
                        {...{ codigo }}
                        open={openModalUpload}
                        handleClose={() => setOpenModalUpload(false)}
                    />
                }
                {
                    openFinalizarTarefa &&
                    <DialogFinalizarProcesso
                        handleOK={handleFinalizarTarefa}
                        open={openFinalizarTarefa}
                        handleClose={() => setOpenFinalizarTarefa(false)}
                        isLoading={isLoadingFinalizarTarefa}
                    />
                }
                {
                    openModalViewer &&
                    <DialogVisualizacaoArquivos
                        open={openModalViewer}
                        clienteInfo={{
                            codigo: codigo_publico,
                            tipo: tipo_publico,
                        }}
                        handleClose={() => setopenModalViewer(false)}
                    />
                }
            </Box>
            <Box position={'relative'} right={-24}>
                <TableMenuOptions
                    menuItems={[
                        {
                            label: "Finalizar Processo",
                            action: () => handleFinalizarPress(),
                            icon: <DoneIcon sx={{ color: "primary" }} />,
                            disabled: podeFinalizarProcesso,
                        },
                        {
                            label: "Visualizar documentos CopyNorte",
                            action: () => setopenModalViewer(true),
                            icon: <FolderCopyIcon sx={{ color: "primary" }} />,
                            disabled: false
                        }
                    ]}
                />
            </Box>
        </Box>
    )
}

interface InfoProps {
    usuario: string,
    usuario_status: string,
    perfil: string,
    perfil_solicitante: string | null,
    criadoEm: string,
    situacao: TTagsSituacao,
    arquivos: TDetalheProcessoAnexos[],
    tarefas: IDetalheTarefas[],
    codigo: string
    codigo_publico: string
    tipo_publico: string
    proximo_processo: string | null
}

interface IFileInput {
    id: number,
    nome: string,
    formato: string
}